<div class="modal-header">
  <h2 class="modal-title fw-bold">Edit Service Registration</h2>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <!-- Current Registration Info -->
    <div class="alert alert-info d-flex align-items-start mb-6">
      <i class="fa fa-info-circle fs-2x me-3 mt-1"></i>
      <div>
        <div class="fw-bold mb-2">Current Registration</div>
        <div class="mb-1">
          <strong>User:</strong>
          @if (registration.user) {
            {{ registration.user.first_name }} {{ registration.user.last_name }}
            @if (registration.user.email) {
              <span class="text-muted">({{ registration.user.email }})</span>
            }
          } @else {
            <span class="text-muted">N/A</span>
          }
        </div>
        <div>
          <strong>Number of Registrations:</strong>
          <span class="badge badge-light-primary ms-2">{{ registration.num_registrations }}</span>
        </div>
      </div>
    </div>

    <!-- User Search Field -->
    <div class="mb-5">
      <label class="form-label required">User</label>
      <div class="position-relative">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="userSearchTerm"
            [ngModelOptions]="{standalone: true}"
            (input)="onUserSearch()"
            placeholder="Search by name or email..."
            [class.is-invalid]="userIdInvalid"
          />
          @if (selectedUser) {
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="clearUserSearch()"
            >
              <i class="fa fa-times"></i>
            </button>
          }
        </div>
        @if (userIdInvalid) {
          <div class="text-danger fs-7 mt-1">User is required</div>
        }

        <!-- User Dropdown -->
        @if (filteredUsers.length > 0 && userSearchTerm && !selectedUser) {
          <div class="user-dropdown position-absolute w-100 bg-white border rounded shadow-sm mt-1" style="z-index: 1000; max-height: 300px; overflow-y: auto;">
            @for (user of filteredUsers; track user.user_id) {
              <div
                class="user-item p-3 cursor-pointer hover-bg-light border-bottom"
                (click)="selectUser(user)"
              >
                <div class="fw-semibold">{{ user.first_name }} {{ user.last_name }}</div>
                @if (user.email) {
                  <div class="text-muted fs-7">{{ user.email }}</div>
                }
              </div>
            }
          </div>
        }

        <!-- Selected User Display -->
        @if (selectedUser) {
          <div class="mt-3 p-4 bg-light rounded">
            <div class="fw-bold mb-2">Selected User</div>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="text-muted fs-7">Name</div>
                <div class="fw-semibold">{{ selectedUser.first_name }} {{ selectedUser.last_name }}</div>
              </div>
              @if (selectedUser.email) {
                <div class="col-md-6">
                  <div class="text-muted fs-7">Email</div>
                  <div class="fw-semibold">{{ selectedUser.email }}</div>
                </div>
              }
              <div class="col-md-6">
                <div class="text-muted fs-7">User ID</div>
                <div class="fw-semibold">{{ selectedUser.user_id }}</div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Number of Registrations -->
    <div class="mb-5">
      <label class="form-label required">Number of Registrations</label>
      <input
        type="number"
        class="form-control"
        formControlName="num_registrations"
        placeholder="Enter number of registrations"
        min="1"
        [class.is-invalid]="form.get('num_registrations')?.invalid && form.get('num_registrations')?.touched"
      />
      @if (form.get('num_registrations')?.invalid && form.get('num_registrations')?.touched) {
        <div class="text-danger fs-7 mt-1">
          @if (form.get('num_registrations')?.errors?.['required']) {
            Number of registrations is required
          }
          @if (form.get('num_registrations')?.errors?.['min']) {
            Number of registrations must be at least 1
          }
        </div>
      }
    </div>
  </form>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'Cancel'"
    (clicked)="close()"
    [disabled]="saving"
  />
  <app-button
    [variant]="'primary'"
    [label]="saving ? 'Saving...' : 'Save Changes'"
    [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
    (clicked)="save()"
    [disabled]="saving || form.invalid"
  />
</div>
